var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"admin-panel admin-layout-wrapper",attrs:{"id":"wrapper"}},[_c('t-side-nav'),_c('t-header'),_c('div',{staticClass:"page-content admin-main-content"},[_c('div',{staticClass:"p-4 admin-content-container"},[_c('router-view')],1),_c('div',{staticClass:"admin-footer-wrapper"},[_c('t-footer',{attrs:{"isCompanyPage":true}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }